import React, { FC, useState } from 'react'
import { useFetchInfowindow } from 'services/infowindow'
import { useTranslation } from 'react-i18next'
import { UpdateFeatureDialog } from './components/UpdateFeatureDialog'
import { DeleteFeatureDialog } from './components/DeleteFeatureDialog'
import { Popup } from 'react-map-gl'
import { Stack } from 'components/Stack'
import { Button } from 'components/Button'
import { Flex } from 'components/Flex'
import { Spinner } from 'components/Spinner'
import { renderItem } from './InfowindowItems'
import styles from './Infowindow.module.scss'

type InfowindowProps = {
  infowindowId: number
  layerId: number
  lngLat: number[]
  editable2: boolean
  onClose: () => void
}

export const Infowindow: FC<InfowindowProps> = ({
  infowindowId,
  layerId,
  lngLat,
  editable2,
  onClose,
}) => {
  const { data: infowindow, status } = useFetchInfowindow(infowindowId, layerId)
  const [updateDialog, setUpdateDialog] = useState(false)
  const [deleteDialog, setDeleteDialog] = useState(false)
  const { t } = useTranslation()

  return (
    <Popup
      latitude={lngLat[1]}
      longitude={lngLat[0]}
      className={styles.infowindow}
      onClose={onClose}
      closeOnClick={false}
    >
      {status === 'loading' && (
        <Flex justify="center" align="center" className={styles.loading}>
          <Spinner />
        </Flex>
      )}

      {status === 'success' && infowindow?.data && (
        <>
          <Stack
            component="ul"
            space="small"
            style={{
              maxHeight: 300,
              overflowY: 'auto',
            }}
          >
            {infowindow.data.map(renderItem)}
            {editable2 === true && (
              <Flex justify="end" gap="sm">
                <Button size="small" variant="secondary" onClick={() => setUpdateDialog(true)}>
                  {t('infowindow.edit')}
                </Button>
                <Button size="small" variant="danger" onClick={() => setDeleteDialog(true)}>
                  {t('infowindow.delete')}
                </Button>
              </Flex>
            )}
          </Stack>
          {updateDialog && (
            <UpdateFeatureDialog
              layerId={layerId}
              infowindowId={infowindowId}
              infowindow={infowindow}
              close={() => setUpdateDialog(false)}
            />
          )}
          {deleteDialog && (
            <DeleteFeatureDialog
              layerId={layerId}
              infowindowId={infowindowId}
              close={() => onClose()}
              cancel={() => setDeleteDialog(false)}
            />
          )}
        </>
      )}
    </Popup>
  )
}

Infowindow.displayName = 'Infowindow'
